import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState, useMemo, useEffect } from 'react';
import { useCreateAiLearning } from '../../../hooks/queries/aiQueries';
import { positiveNumberInputFormatter } from '../../../utils/utils';
import dayjs from 'dayjs';
import DateTimeInput from '../../../components/DateTimeInput/DateTimeInput';
import AiModuleSelect from './AiModuleSelect';
const AiLearningCblReRequestModal = ({onClose, onSuccess}) => {


  const createAiLearning = useCreateAiLearning();

  const [selectedExistingModule, setSelectedExistingModule] = useState(null);
  const [selectedDemandModule, setSelectedDemandModule] = useState(null);

  const [formDataForRe, setFormDataForRe] = useState({
    "selectedModelName": null,
    "aiModelType": 'CblPrediction',
    "selectedModelVersion": null,
    "interationCount": null,
    "startDate": null,
    "endDate": null,
    "isNewModel": false,
    "originAiAlgorithm": null,
    "demandPredictionAiModelName": null,
    "demandPredictionAiModelVersion": null
  });

  const handleFormDataForReChange = (key, value) => {
    setFormDataForRe({ ...formDataForRe, [key]: value });
  };

  const canComplete = useMemo(() => {
    if (!formDataForRe.interationCount) return false;
    if (parseInt(formDataForRe.interationCount) <= 0) return false;
    if (!formDataForRe.startDate) return false;
    if (!formDataForRe.endDate) return false;
    return true;
  }, [formDataForRe]);

  const buildApiPayload = () => {
    return {
      selectedModelName: formDataForRe.selectedModelName || '',
      aiModelType: 'CblPrediction',
      selectedModelVersion: formDataForRe.selectedModelVersion || '',
      interationCount: parseInt(formDataForRe.interationCount),
      startDate: formDataForRe.startDate ? dayjs(formDataForRe.startDate).toISOString() : '',
      endDate: formDataForRe.endDate ? dayjs(formDataForRe.endDate).toISOString() : '',
      isNewModel: false,
      originAiAlgorithm: formDataForRe.originAiAlgorithm || '',
      demandPredictionAiModelName: formDataForRe.demandPredictionAiModelName || '',
      demandPredictionAiModelVersion: formDataForRe.demandPredictionAiModelVersion || '',
    };
  };

  const handleComplete = async () => {
    if (!canComplete) return;
    const payload = buildApiPayload();
    if (!payload) {
      alert('잘못된 요청 타입입니다.');
      return;
    }
    try {
      await createAiLearning.mutateAsync(payload);
      if (onSuccess) {
        onSuccess();
      }
      handleClose();
    } catch (error) {
      console.error('AI 학습 요청 실패:', error);
      alert(`AI 학습 요청 등록에 실패했습니다:`);
    }
  };

  const handleClose = () => {
    setFormDataForRe({
      "selectedModelName": null,
      "aiModelType": null,
      "selectedModelVersion": null,
      "interationCount": null,
      "startDate": null,
      "endDate": null,
      "isNewModel": false,
      "originAiAlgorithm": null,
      "demandPredictionAiModelName": null,
      "demandPredictionAiModelVersion": null
    });
    createAiLearning.reset();
    onClose();
  };

  useEffect(() => {
    if(selectedExistingModule) {
      setFormDataForRe({
        ...formDataForRe,
        selectedModelName: selectedExistingModule.ModuleName,
        selectedModelVersion: selectedExistingModule.Version,
      });
    }
  }, [selectedExistingModule]);
  useEffect(() => {
    if(selectedDemandModule) {
      setFormDataForRe({
        ...formDataForRe,
        demandPredictionAiModelName: selectedDemandModule.ModuleName,
        demandPredictionAiModelVersion: selectedDemandModule.Version,
      });
    }
  }, [selectedDemandModule]);

  return (
    <div className="modal-background">
      <div className="modal-container learning-demand-re-request-modal">
        <div className="modal-header">
          <h3>CBL 예측 모듈 재학습 요청</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content flex flex-col gap-10 p-10">
          <div className='grid grid-cols-3 gap-10 align-center mb-20'>
            <div className='flex flex-col gap-2'>
              <p className='text-b2-400 text-gray-800'>학습 횟수</p>
              <input type="text" className='input-primary' placeholder='학습 횟수를 입력하세요 (숫자)' onInput={(e) => positiveNumberInputFormatter(e)} value={formDataForRe.interationCount} onChange={(e) => handleFormDataForReChange('interationCount', e.target.value)} />
            </div>
            <div className='flex flex-col gap-2'>
              <p className='text-b2-400 text-gray-800'>학습 데이터 시작 일시</p>
              <DateTimeInput
                type="date"
                value={formDataForRe.startDate}
                onChange={(value) => handleFormDataForReChange('startDate', value)}
                placeholder="시작일을 선택하세요"
                max={formDataForRe.endDate}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <p className='text-b2-400 text-gray-800'>학습 데이터 종료 일시</p>
              <DateTimeInput
                type="date"
                value={formDataForRe.endDate}
                onChange={(value) => handleFormDataForReChange('endDate', value)}
                placeholder="종료일을 선택하세요"
                min={formDataForRe.startDate}
              />
            </div>
          </div>
          <div className='flex flex-col gap-2'>
            <p className='text-b2-400 text-gray-800'>기존 AI 모듈 선택</p>
            {/* 기존 AI 모듈 선택 컴포넌트 */}
            <AiModuleSelect mode="all" selectedModule={selectedExistingModule} setSelectedModule={setSelectedExistingModule} />
          </div>
          <div className='flex flex-col gap-2'>
            <p className='text-b2-400 text-gray-800'>충전량 예측 모듈 선택</p>
            {/* 충전량 예측 모듈 선택 컴포넌트 */}
            <AiModuleSelect mode="demand" selectedModule={selectedDemandModule} setSelectedModule={setSelectedDemandModule} />
          </div>


          
          <div className='flex justify-end'>
            <button className='btn btn-primary big-btn' onClick={handleComplete} disabled={createAiLearning.isPending || !canComplete}>
              {createAiLearning.isPending ? '재학습 요청 중...' : '재학습 요청'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AiLearningCblReRequestModal